export default __webpack_public_path__ + "static/media/15.0b4a7860.jpg";